import React from "react";
import Messages from "../../common/Messages";

const TeacherMessages: React.FC = () => {
  return <Messages userRole="teacher" conversationType="ProblemConversation" />;
};

export default TeacherMessages;
